import { Textures } from '@types'

/** Encimeras/frontales recalculan UVs cuando cambia el grupo contiguo (contador global). */
export function isContiguousSurfaceZone(textures: Textures, zoneName: string): boolean {
  const meta = textures.find((texture) => texture.zoneName === zoneName)
  if (!meta) return false
  return (
    meta.zone === 'Encimera' ||
    meta.zoneDisplayName === 'Encimera' ||
    meta.zone === 'Frontal' ||
    meta.zoneDisplayName === 'Frontal'
  )
}
